export default __webpack_public_path__ + "static/media/location-access.24c2e63b.gif";